import {SetupWorker, setupWorker} from 'msw/browser';
import {handlers} from '@resurs-internal/rb-app-api/mock/handlers';
import {mockedUnhandledRequestPattern} from '@resurs-internal/rb-app-api';
import {LocalServiceOverride} from '../localServiceOverride';

let serviceWorker: SetupWorker | null = null;
let isActive = false;
const getMockServiceWorker = () => {
  if (serviceWorker) return serviceWorker;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  serviceWorker = setupWorker(...handlers);
  return serviceWorker;
};

const start = async () => {
  if (isActive) {
    return;
  }

  LocalServiceOverride.stop();

  try {
    isActive = true;
    await getMockServiceWorker().start({
      onUnhandledRequest(request, print) {
        const url = new URL(request.url);
        if (
          mockedUnhandledRequestPattern.some((pattern) =>
            url.href.includes(pattern),
          )
        ) {
          return;
        }

        print.warning();
      },
    });
  } catch (error) {
    console.error('[MockServiceWorker] Failed to start:', error);
    isActive = false;
    throw error;
  }
};

const stop = () => {
  isActive = false;
  if (serviceWorker) serviceWorker.stop();
  LocalServiceOverride.start();
};

export const MockServiceWorker = {
  start,
  stop,
  isActive: () => isActive,
} as const;
